import { initialValuesNeighborhood as initialValues } from '../../../../../../../helpers/variablesInitialValues';
import * as types from '../types/neighborhoodType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const neighborhoodReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_NEIGHBORHOOD:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_NEIGHBORHOOD:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_NEIGHBORHOOD:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_NEIGHBORHOOD:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_NEIGHBORHOOD:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_NEIGHBORHOOD:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_NEIGHBORHOOD:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_NEIGHBORHOOD:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_NEIGHBORHOOD:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_NEIGHBORHOOD:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_NEIGHBORHOOD:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_NEIGHBORHOOD:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default neighborhoodReducer;
